"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.withShellContext = void 0;
var withShellContext_1 = require("./withShellContext");
Object.defineProperty(exports, "withShellContext", { enumerable: true, get: function () { return __importDefault(withShellContext_1).default; } });
